module.exports = __webpack_public_path__ + "3cdc86d1f6aea391ac799c14f62bfe9d.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/medic.png
 ** module id = 1068
 ** module chunks = 0
 **/